
export const getMetersLabelByLanguange = (language: string = 'en') => {
    if (language === 'ar') {
        return 'متر';
    }
    return 'm';
}